import React from "react";
import { Link, Spinner } from "components/common";
import Routes from "routing/Routes";
const LinkToAPIToken = ({ user = void 0, children }) => {
  if (!user) {
    return /* @__PURE__ */ React.createElement(Spinner, null);
  }
  return /* @__PURE__ */ React.createElement(Link, { target: "_blank", to: Routes.SYSTEM.USERS.TOKENS.edit(user.id) }, children);
};
export default LinkToAPIToken;
